import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Constant} from '../../global/util/Constant';
import {Observable} from 'rxjs';
import {Headers} from '../../global/util/Headers';
import {Installer} from '../model/Installer';

@Injectable({
  providedIn: 'root'
})
export class InstallerService {

  private url = Constant.ROOT_API_V1.concat('/installers');

  constructor(private http: HttpClient) {
  }

  public get(url: string) {
    return this.http.get(url);
  }

  public getOf(url: string): Observable<any> {
    return this.http.get(url, {responseType: 'blob'});
  }

  public save(formData: FormData): Observable<any> {
    return this.http.post(this.url, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  public edit(installer: Installer): Observable<any> {
    return this.http.put(this.url, JSON.stringify(installer), Headers.contentType);
  }

  public delete(installer: Installer) {
    const url = this.url.concat('/', String(installer.id));
    return this.http.delete(url);
  }
}
